import dayjs from 'dayjs';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const DayjsLocalizationProvider = ({ children }: { children: ReactNode }) => {
  const { i18n } = useTranslation();

  // Always use the latest language.
  dayjs.locale(i18n.language.toLowerCase());

  return children;
};
